import * as React from "react";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box, useMediaQuery, useTheme } from "@mui/material";

const ACTAlertWarning = ({ message, severity = "error", onHide }) => {
  const handleHideAlert = () => {
    onHide();
  };

  const handleDontShowAgain = () => {
    onHide();
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack
      sx={{
        width: "100%",
        display: "flex",
      }}
      spacing={2}
    >
      <Alert
        sx={{
          display: "flex",
          alignItems: "center",
          color: "inherit",
        }}
        severity={severity}
        action={
          <Box
            sx={{
              display: "flex",
              // width: "30vw",
              justifyContent: "flex-end",
              padding: "0 0 0 1rem",
              margin: "-0.1rem 0 0.1rem 0",
              gap: isMobile ? "0" : "1rem",
            }}
          >
            {/* <button
              style={{
                marginRight: "0",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              size="small"
              onClick={handleDontShowAgain}
            >
              Don't show again
            </button> */}
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleHideAlert}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        }
      >
        <Box
          sx={{
            textAlign: "left",
          }}
        >
          {message}
        </Box>
      </Alert>
    </Stack>
  );
};

export default ACTAlertWarning;
